export default function($) {
  var speed = 180; // ms

  $('.js-search-trigger').click(function () {
    $('.js-search-container').slideDown(speed);
    $('.js-search-container').addClass('search-container-open');
    $(this).addClass('search-trigger-active');
  });
  $('.js-search-close').click(function () {
    $('.js-search-container').slideUp(speed);
    $('.js-search-container').removeClass('search-container-open');
    $(this).removeClass('search-trigger-active');
  });
}
